module.exports = __webpack_public_path__ + "static/media/avatar_46.76b8eb79.svg";